import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Image360Carousel } from '../../components';

const Image360CarouselContainer = props => {
  return (
    <Image360Carousel
      images={props.images}
      shared={props.shared}
      video={props.video}
      vfmFlagImages={props.vfmFlagImages}
      is360Display={props.is360Display}
      productGalleryContentCloudName={props.productGalleryContentCloudName}
      productNumber={props.productNumber}
    />
  );
};

Image360CarouselContainer.propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape({
    thumbnailURL: PropTypes.string.isRequired,
    largeImageURL: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
  })).isRequired,
  shared: PropTypes.shape({
    isShared: PropTypes.bool.isRequired,
    sharedMessage: PropTypes.string.isRequired,
  }).isRequired,
  video: PropTypes.shape({
    thumbnailURL: PropTypes.string,
    videoURL: PropTypes.string,
  }).isRequired,
  vfmFlagImages: PropTypes.arrayOf(PropTypes.shape({
    imageURL: PropTypes.string.isRequired,
    imageName: PropTypes.string.isRequired,
    hoverText: PropTypes.string.isRequired,
  })).isRequired,
  is360Display: PropTypes.bool.isRequired,
  productGalleryContentCloudName: PropTypes.string.isRequired,
  productNumber: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  images: state.ImageCarousel.images,
  shared: state.ImageCarousel.shared,
  video: state.ImageCarousel.video,
  vfmFlagImages: state.ImageCarousel.vfmFlagImages,
  is360Display: state.ImageCarousel.is360Display,
  productGalleryContentCloudName: state.ImageCarousel.productGalleryContentCloudName,
  productNumber: state.ImageCarousel.productNumber,
});

export default connect(mapStateToProps)(Image360CarouselContainer);



// WEBPACK FOOTER //
// ./src/main/ui/react/product/src/containers/Image360Carousel/Image360Carousel.js